import React from 'react'
import AppModal from '../common/AppModal'
import CreateOrUpdateItemForm from '../../forms/CreateOrUpdateItemForm'

interface CreateItemModalProps {
  open: boolean
  onClose: () => void
  loading: boolean
  error: string | null
}

const CreateItemModal: React.FC<CreateItemModalProps> = ({ open, onClose, loading, error }) => (
  <AppModal open={open} onClose={onClose} title="Create New Item" width="md" loading={loading}>
    <CreateOrUpdateItemForm loading={loading} error={error} />
  </AppModal>
)

export default CreateItemModal
